import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Scene } from "@/model";
import sceneRepository from "@/repository/sceneRepository";
import { sceneKeys } from "./keys";


export const useCreateScene = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<Scene, Error, Partial<Scene>>({
        mutationFn: async (scene: Partial<Scene>) => {
            const data = await sceneRepository.create(scenarioId, scene);
            return data.data!;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: sceneKeys.all(scenarioId) });
        }
    });
};
